<template>
  <el-dialog
    class="my-dialog"
    :visible.sync="showDialog"
    :before-close="beforeClose"
    :destroy-on-close="true"
    width="508px"
    :close-on-click-modal="false"
  >
    <!-- 协议弹窗 -->
    <el-dialog
      title="用户协议"
      :visible.sync="dialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="60%"
      :modal-append-to-body="false"
      append-to-body
    >
      <div style="max-height: 60vh; overflow-y: auto" v-html="content"></div>
    </el-dialog>
    <div class="login-con">
      <div slot="header" class="clearfix">
        <h1>{{ CONFIG_PROJECT.title }}</h1>
      </div>
      <div class="loginType">
        <div
          :class="loginType === 'scanQRCode' ? 'active' : ''"
          @click="loginType = 'scanQRCode'"
        >
          微信扫码登录
        </div>
        <div
          :class="loginType === 'password' ? 'active' : ''"
          @click="loginType = 'password'"
        >
          手机验证码登录
        </div>
        <div
          :class="loginType === 'account' ? 'active' : ''"
          @click="loginType = 'account'"
        >
          账号密码登录
        </div>
      </div>

      <MobileLogin
        v-if="loginType === 'password'"
        @submitHandler="submitHandler"
        @getProtocol="getProtocol"
      />
      <ScanQRcode v-if="loginType === 'scanQRCode'" @submitHandler="submitHandler" />
      <AccountMain v-if="loginType === 'account'" @accountLogin="accountLogin" @accountRegister="accountRegister"/>
    </div>
  </el-dialog>
</template>

<script>
import CONFIG_PROJECT from "@config/project";

import logo from "@images/logo.png";
import ScanQRcode from "@/pages/login/components/scan-QR-code.vue";
import MobileLogin from "@/pages/login/components/mobile-login.vue";
import AccountMain from "@/pages/login/components/account-main.vue";
import { mapState, mapMutations } from "vuex";
export default {
  head: {
    title: "登录",
  },
  components: {
    ScanQRcode,
    MobileLogin,
    AccountMain,
  },
  layout: "empty",
  data() {
    return {
      showDialog: true,
      logoSrc: logo,
      CONFIG_PROJECT,

      loginType: "scanQRCode",
      dialogVisible: false,
      content: "",
    };
  },
  computed: {
    ...mapState("userinfo", {
      showCallBack: (state) => state.showCallBack,
    }),
  },
  methods: {
    beforeClose(done) {
      //   if (this.timers != null) {
      //     clearInterval(this.timers);
      //   }
      //   if (this.timeout) {
      //     clearTimeout(this.timeout);
      //   }

      //   this.$store.commit("login/resetState");
      this.$store.commit("userinfo/upateLoginState", { show: false, callback: null });
      done();
    },
    //点击logo跳转首页
    loginClick() {
      this.$router.push({
        path: "/",
      });
    },
    submitHandler(data) {
      this.$store.dispatch("userinfo/smsloginHandler", {
        data,
        success: () => {
          this.checkShowVip();
        },
      });
    },
    accountRegister(data) {
      this.$store.dispatch("userinfo/accountRegisterHandler", {
        data,
        success: () => {
          this.$notify({
            message: "注册成功",
            type: "success",
          });
          this.checkShowVip();
        },
      });
    },
    accountLogin(data) {
      this.$store.dispatch("userinfo/accountLoginHandler", {
        data,
        success: () => {
          this.checkShowVip();
        },
      });
    },
    //查询是否购买过会员 true代表购买过 false 没有买过
    checkShowVip() {
      this.$get(`${this.$store.state.api.webUrl}/uservip/isPurchase.json`, {}, (data) => {
        setSession("showReceiveVip", data.result ? 0 : 1);
        this.redirectUrl();
      });
    },

    redirectUrl() {
      if (!!this.showCallBack) {
        this.showCallBack();
        this.$store.commit("userinfo/upateLoginState", { show: false, callback: null });
      } else {
        // window.location.reload();
        this.$store.commit("userinfo/upateLoginState", { show: false, callback: null });
      }
    },
    //获取协议说明
    getProtocol() {
      this.$get(`${this.$store.state.api.webUrl}/coin/getprotocol.json`, {}, (data) => {
        this.content = data.content;
        this.dialogVisible = true;
      });
    },
  },
  mounted() {
  },
  created(){
  }
};
</script>
<style lang="scss" scoped>
@import "@css/var.scss";
.my-dialog {
  ::v-deep {
    .el-dialog__body {
      padding: 25px 40px;
      margin-top: 10px;
    }
  }
}

.login-page {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: url(~@images/login/bg.jpg) no-repeat $primaryColor;
  background-size: cover;
}

.logo-corner {
  position: absolute;
  left: 50%;
  top: 30px;
  transform: translateX(-600px);

  img {
    height: 48px;
  }
}

.login-con {
  //   width: 390px;
  //   height: 420px;
  //   position: absolute;
  //   left: 50%;
  //   top: calc(50% - 40px);
  //   transform: translate(-50%, -50%);
  //   background-color: rgba(255, 255, 255, 1);
  //   border-radius: 10px;
  //   margin-top: 10px;

  h1 {
    text-align: center;
    font-size: 36px;
    font-weight: normal;
    padding: 0 20px 20px 20px;
  }

  .loginType {
    display: flex;
    justify-content: space-between;
    padding: 0 40px;

    div {
      font-size: 16px;
      cursor: pointer;
      padding-bottom: 6px;
    }
    div.active {
      border-bottom: 2px solid #137dff;
      color: #137dff;
    }
  }
}

.info {
  color: #666666;
  margin-top: 50px;
  line-height: 1em;
}
</style>
